module.exports = __webpack_public_path__ + "img/payment.6e259c1c.png";